export enum TapeType {
  MOVIE = 'movie',
  STATUS = 'status',
}
